import {useContext, useRef, useState, useEffect} from "react"
import styles from "./VoiceCallPanel.module.css"
import {VoiceCallContext} from "context/VoiceCallContext"
import Draggable from "react-draggable"
import {VoiceCallStudentPanel} from "../VoiceCallStudentPanel"

export function VoiceCallPanel() {
    const {calling, activeStudent, queuedStudents} = useContext(VoiceCallContext)

    const containerRef = useRef<HTMLDivElement>(null)
    if ((queuedStudents.length === 0 && !calling) || !activeStudent) return null

    return (
        <Draggable bounds="parent" nodeRef={containerRef}>
            <div ref={containerRef} className={styles.containerWrap}>
                <VoiceCallStudentPanel />
            </div>
        </Draggable>
    )
}
